module.exports = __webpack_public_path__ + "img/ic24Phone.f358f8d4.svg";